<template>
  <span :class="[
    'button',
    'button--' + theme,
    'button--' + shape
  ]">
    <span
      class="slot"
      :class="[
        'slot',
        'slot--' + arrow,
        'slot--' + shape
      ]"
    >
      <slot></slot>
    </span>

    <svg
      :class="[
        'arrow',
        'arrow--' + arrow,
        'arrow--' + shape
      ]"
      viewBox="0 0 11.73 15.88"
      width="8.55"
      height="11.58"
    >
      <path d="M0 15.88V0l11.73 7.94L0 15.88z" />
    </svg>
  </span>
</template>

<script>
export default {
  name: 'Button',
  props: {
    theme: {
      type: String,
      default: 'yellow'
    },
    arrow: {
      type: String,
      default: 'end'
    },
    shape: {
      type: String,
      default: 'regular'
    }
  }
}
</script>

<style lang="scss" scoped>
  .button {
    outline: 0;
    border-radius: 0;
    box-shadow: none;
    color: black;
    font-family: $ff-rijksheading;    
    background: none;
    border: none;
    text-transform: uppercase;
    font-size: 0;
    padding: 0;
    position: relative;
    display: inline-block;
    cursor: pointer;
    font-weight: bold;

    &--yellow {
      background-color: $c-yellow;
    }
    &--white {
      background-color: white;
    }
    &--blank {
      background-color: transparent;
    }
  }

  .slot {
    display: block;
    text-decoration: none;

    & > * {    
      padding: 9px 15px;
      font-size: 18px;
      display: block;
      color: black;
      letter-spacing: 0.047em;
      text-decoration: none;

      @media (max-width: 479px) {
        font-size: 16px;
      }

      &:hover, &:focus, &:visited, &:active {
        text-decoration: none;
        color: black;
      }

      a {
        color: black;
        text-decoration: none;

        &:hover, &:focus, &:visited, &:active {
          text-decoration: none;
          color: black;
        }
      }
    }

    &--begin > * {
      padding-left: 40px;
    }
    &--end > * {
      padding-right: 40px;
    }
    &--minimal {
      & > * {
        padding: 0;
      }

      &.slot--begin > * {
        padding-left: 25px;
      }
      &.slot--end > * {
        padding-right: 25px;
      }
    }
  }

  .arrow {
    position: absolute;
    top: 16px;

    @media (max-width: 479px) {
      top: 14px
    }

    &--begin {
      left: 15px;
      transform: rotate(180deg);
    }
    &--end {
      right: 15px;
    }

    &--minimal {
      top: 7px;

      @media (max-width: 479px) {
        top: 5px;
      }

      &.arrow--begin {
        left: 0;
      }
      &.arrow--end {
        right: 0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Button.vue